<div *ngIf="headerViewModel$ | async as vm" class="root">
    <ng-container *transloco="let t; read:'permit'">
        <div class="root__top-bar" [class.root__top-bar--create]="vm.currentComponent === PermitCompononent.Create">
            <a class="root__top-bar__anchor" [routerLink]="['/', PermitPaths.Root]">{{ t("permit") }}</a>
            <div class="root__top-bar__panel-container" [class.root__top-bar__panel-container--create]="vm.currentComponent === PermitCompononent.Create">
                <ng-container *ngIf="vm.showDemoBadge">
                    <div class="root__top-bar__panel root__top-bar__demo">{{ t("demo") }}</div>
                </ng-container>
                <ng-container *ngIf="vm.permitBadge as permitBadge">
                    <div
                        class="root__top-bar__panel root__top-bar__type-badge"
                        [class.root__top-bar__type-badge--premium]="permitBadge.type === 'premium'"
                        [class.root__top-bar__type-badge--flammable-atex]="permitBadge.type === 'flammable-atex'">
                        <div
                            class="root__top-bar__type-badge__icon"
                            [class.root__top-bar__type-badge__icon--premium]="permitBadge.type === 'premium'"
                            [class.root__top-bar__type-badge__icon--flammable-atex]="permitBadge.type === 'flammable-atex'"></div>
                        <span>{{ t(permitBadge.textKey) }}</span>
                    </div>
                </ng-container>
                <ng-container *ngIf="vm.showBaseBadge">
                    <div class="root__top-bar__panel root__top-bar__base">{{ t("base") }}</div>
                </ng-container>
                <div *ngIf="permitId" class="root__top-bar__panel root__top-bar__permit-id">ID: {{ permitId }}</div>
            </div>
        </div>
        <div class="root__top-bar__workplace" #workplaceSection *ngIf="vm.hasWorkplace">
            <div class="root__top-bar__workplace__icon"></div>
            <div class="root__top-bar__workplace__text">
                <div class="root__top-bar__workplace__container" *ngIf="vm.details?.workplaceContainer">
                    {{ vm.details?.workplaceContainer }}
                </div>
                <div class="root__top-bar__workplace__workplace" *ngIf="vm.details?.workplace">
                    {{ vm.details?.workplace }}
                </div>
            </div>
        </div>
    </ng-container>

    <pmt-permit-create
        class="root__content"
        [class.root__content--has-workplace]="vm.hasWorkplace"
        [permitId]="permitId"
        *ngIf="vm.currentComponent === PermitCompononent.Create"></pmt-permit-create>

    <pmt-permit-details
        class="root__content"

        [permitId]="permitId"
        *ngIf="vm.currentComponent === PermitCompononent.Details"></pmt-permit-details>
</div>
